import * as React from "react";

const SvgHeart = React.forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 155.21 180.39"
      {...props}
			ref={ref}
    >
      <defs>
        <style>
          {
            ".heart_svg__cls-1{fill:#ff0a0a}.heart_svg__cls-2{fill:none;stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:3.13px}"
          }
        </style>
      </defs>
      <g id="heart_svg__heart-left" opacity={0} style={{transformOrigin: 'center center'}}>
        <path
          className="heart_svg__cls-1"
          d="M15.34 117.59a21.07 21.07 0 0116.25 7.33c1.92-1.59 3.51-3.51 5.42-4.78 7.65-6.06 10.84-6.38 19.76-1.28a14.14 14.14 0 018 14.35 25.64 25.64 0 01-6.69 16.89 58.85 58.85 0 00-9.88 11.79 55.54 55.54 0 01-14.35 16.9c-3.5 2.55-4.78 2.55-7.33-1-5.73-8-11.47-15.94-16.57-24.22a38.21 38.21 0 01-6.06-25.5c.64-6.7 5.74-11.16 11.48-10.52"
          transform="translate(-2.06 -1.77)"
        />
        <path
          className="heart_svg__cls-2"
          d="M15.34 117.59a21.07 21.07 0 0116.25 7.33c1.92-1.59 3.51-3.51 5.42-4.78 7.65-6.06 10.84-6.38 19.76-1.28a14.14 14.14 0 018 14.35 25.64 25.64 0 01-6.69 16.89 58.85 58.85 0 00-9.88 11.79 55.54 55.54 0 01-14.35 16.9c-3.5 2.55-4.78 2.55-7.33-1-5.73-8-11.47-15.94-16.57-24.22a38.21 38.21 0 01-6.06-25.5c.61-6.66 5.71-11.07 11.45-10.48z"
          transform="translate(-2.06 -1.77)"
        />
      </g>
      <g id="heart_svg__heart-right" opacity={0} style={{transformOrigin: 'center center'}}>
        <path
          className="heart_svg__cls-1"
          d="M96.94 77.74a37.15 37.15 0 0110.2 2.55c7.33 3.19 12.11 8.93 16.57 16.58q5.29-2.87 9.56-4.78c8-3.51 17.22-.32 20.72 7.65a19.22 19.22 0 011.6 5.74 33.59 33.59 0 01-12.43 29.32c-6.06 5.1-12.75 9.88-19.13 15a72.71 72.71 0 01-13.71 10.2c-5.1 2.23-6.37 1.91-8.6-3.19-3.51-8.6-7-16.89-10.2-25.5-2.87-8-6.06-15.93-8.29-24.22a30 30 0 011.59-21.68 11.84 11.84 0 0112.12-7.65"
          transform="translate(-2.06 -1.77)"
        />
        <path
          className="heart_svg__cls-2"
          d="M96.94 77.74a37.15 37.15 0 0110.2 2.55c7.33 3.19 12.11 8.93 16.57 16.58q5.29-2.87 9.56-4.78c8-3.51 17.22-.32 20.72 7.65a19.22 19.22 0 011.6 5.74 33.59 33.59 0 01-12.43 29.32c-6.06 5.1-12.75 9.88-19.13 15a72.71 72.71 0 01-13.71 10.2c-5.1 2.23-6.37 1.91-8.6-3.19-3.51-8.6-7-16.89-10.2-25.5-2.87-8-6.06-15.93-8.29-24.22a30 30 0 011.59-21.68 11.84 11.84 0 0112.12-7.67z"
          transform="translate(-2.06 -1.77)"
        />
      </g>
      <g id="heart_svg__heart-top" opacity={0} style={{transformOrigin: 'center center'}}>
        <path
          className="heart_svg__cls-1"
          d="M103.17 26.79a13.08 13.08 0 00-6.66-15.43C92.3 8.9 87.74 7.85 83.18 8.9c-7.36 1.41-14.37 4.91-20.68 9.47a33 33 0 00-4.21-7.71c-2.1-2.46-4.21-5.61-7-6.31A19.78 19.78 0 0026.38 17c-.35.7-.35 1.75-.7 2.45a38.5 38.5 0 001.05 17.85C30.94 51 36.2 64 41.46 77.28a18.31 18.31 0 004.91 6.66c4.56 4.91 7.71 4.91 12.62.7 3.86-3.16 7.36-6.66 10.87-9.82A126.48 126.48 0 00100 35.55a32.06 32.06 0 003.16-8.76"
          transform="translate(-2.06 -1.77)"
        />
        <path
          className="heart_svg__cls-2"
          d="M103.17 26.79a13.08 13.08 0 00-6.66-15.43C92.3 8.9 87.74 7.85 83.18 8.9c-7.36 1.41-14.37 4.91-20.68 9.47a33 33 0 00-4.21-7.71c-2.1-2.46-4.21-5.61-7-6.31A19.78 19.78 0 0026.38 17c-.35.7-.35 1.75-.7 2.45a38.5 38.5 0 001.05 17.85C30.94 51 36.2 64 41.46 77.28a18.31 18.31 0 004.91 6.66c4.56 4.91 7.71 4.91 12.62.7 3.86-3.16 7.36-6.66 10.87-9.82A126.48 126.48 0 00100 35.55a32.06 32.06 0 003.17-8.76z"
          transform="translate(-2.06 -1.77)"
        />
      </g>
    </svg>
  );
});

export default SvgHeart;

